import { assign } from 'lodash'

const development = {
  api: 'https://enlighten-dev.qa-enphaseenergy.com',
}

const test = {
  api: 'https://enlighten-dev.qa-enphaseenergy.com',
}

const qa4 = {
  api: 'https://enlighten-dev.qa-enphaseenergy.com',
}

const intg = {
  api: 'https://enlighten-intg.qa-enphaseenergy.com',
}

const rel = {
  api: 'https://enlighten-rel.enphaseenergy.com',
}

const qa2 = {
  api: 'https://qa2.enphaseenergy.com',
}

const production = {
  api: 'https://enlighten.enphaseenergy.com',
}

const preprod = {
  api: 'https://enlighten-preprod.enphaseenergy.com',
}

const local = {
  api: 'http://localhost:8080',
}

const DEFAULT = {}

const CONFIG = {
  development,
  production,
  preprod,
  test,
  qa2,
  intg,
  rel,
  qa4,
  local,
}

const getEnlightenConfig = (env) => {
  let hostname
  if (typeof window !== 'undefined') {
    hostname = window.location.hostname
    if (hostname.search('batterybonus.enphaseenergy.com') >= 0) {
      env = 'production'
    } else if (hostname.search('batterybonus-preprod.enphaseenergy.com') >= 0) {
      env = 'preprod'
    } else if (hostname.search('batterybonus-stg.qa-enphaseenergy.com') >= 0) {
      env = 'qa2'
    } else if (hostname.search('batterybonus-intg.qa-enphaseenergy.com') >= 0) {
      env = 'intg'
    } else if (hostname.search('batterybonus-rel.qa-enphaseenergy.com') >= 0) {
      env = 'rel'
    } else if (hostname.search('batterybonus-dev.qa-enphaseenergy.com') >= 0) {
      env = 'qa4'
    } else if (window.location.port === '8000') {
      env = 'qa4'
    } else {
      env = 'qa4'
    }
  } else if (env === 'test') {
    env = 'test'
  }

  const envConfig = CONFIG[env]
  if (envConfig) {
    return assign({}, DEFAULT, envConfig)
  }
  throw new Error('Unknown environment : ' + env)
}

export default getEnlightenConfig
